import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BodyMedium, ButtonBase, DivWithShadowAlternate, H4 } from '@styled';
import colors from '@general/colors';
import fonts from '@general/fonts';
import { mediaQueries } from '@general/breakpoints';

const ComponentContainerStyled = styled(DivWithShadowAlternate)`
    background-color: white;
    width: auto;

    @media ${mediaQueries.md} {
        width: 794px;
    }
`;

const BodyContainerStyled = styled.div`
    padding: 20px 24px 32px 24px;

    @media ${mediaQueries.md} {
        padding: 50px 44px 88px 44px;
    }
`;

const GreyDividerStyled = styled.hr`
    border-color: ${colors.lightGray};
    margin: 0;
`;

const ButtonContainerStyled = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 16px 20px 16px 20px;

    @media ${mediaQueries.md} {
        padding: 20px 24px 20px 24px;
    }
`;

const ButtonStyled = styled(ButtonBase)`
    background-color: ${colors.primary};
    border-radius: 0;
    color: ${colors.white};
    cursor: pointer;
    display: inline-block;
    font-family: ${fonts.sans};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.94px;
    line-height: 22px;
    padding: 0.8rem 3rem;
    text-transform: none;

    &:hover {
        background: ${colors.primaryDark};
    }
`;


const AttendeePdfAccessLayout = ({ onAccept, eventLink }) => {
    const handleAccept = () => {
        onAccept();
        window.location.href = eventLink; // Redirect to the PDF link
    };

    return (
        <ComponentContainerStyled>
            <hr
                style={{
                    borderTopWidth: '6px',
                    borderColor: colors.primary,
                    margin: 0,
                }}
            />

            <BodyContainerStyled>
                <H4>Download Attendee List Acknowledgement</H4>

                <BodyMedium className="mt-1rem">
                    By downloading this PDF, I acknowledge that this attendee list is the proprietary property of ICSC
                    and that any reproduction, distribution, or sale of this list is prohibited.
                </BodyMedium>
            </BodyContainerStyled>

            <GreyDividerStyled />

            <ButtonContainerStyled>
                <ButtonStyled onClick={handleAccept}>Continue</ButtonStyled>
            </ButtonContainerStyled>
        </ComponentContainerStyled>
    );
};

AttendeePdfAccessLayout.propTypes = {
    onAccept: PropTypes.func.isRequired,
    eventLink: PropTypes.string.isRequired,
};

export default AttendeePdfAccessLayout;
